import { WOW } from "wowjs";
// mixin主
export const mixin = {
	data(){
	    return {
	        xww:10010,
	        y:200,
			uplink:'http://appapi.nmkargo.com/app/storage/upload',
	    }
	},
    methods:{
		// 跳转pk
		goPK(item){
			item = JSON.stringify(item)
			localStorage.setItem('pkitem1', item);
			this.link('/homePk')
		},
		// 修改价格数据
		changeP(){
			this.selPrice = 0
			for(var i in this.selLGoods){
				this.selPrice += this.selLGoods[i].pricejy*1
			}
			var itemStr = JSON.stringify(this.selLGoods)
			localStorage.setItem('setGmsg', itemStr);
		},
		Tips(message,type){
			this.$message({
				showClose: true,
				message,
				type:type||'error'
			});
		},
		// 路由跳转
		link(url,query={}){
			this.$router.push({path:url,query});
		},
		back(){
			this.$router.back()
		},
    },
    //挂载完毕就执行
    mounted() {
        var options = {
			boxClass:'wow',// default 在用户滚动时显示隐藏框的类名。
			animateClass:'animated',// default 触发 CSS 动画的类名（默认情况下，animmate.css 库为“animated”）
			offset:0,// default 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并达到此距离时，将显示隐藏框。
			mobile:true,// default 在移动设备上打开/关闭 wow.js。
			live:true,// default 持续检查页面上是否有新的 WOW 元素。
        };
        new WOW(options).init();
    },
}
// mixin次
export const shareData = {
    data(){
        return {
            x:10,
            y:20
        }
    }
}
